import { Link } from "react-router-dom";
import type { WatchApp } from "@/mocks/movies";

interface AppRecommendProps {
  apps: WatchApp[];
  onDownload: (app: WatchApp) => void;
}

export default function AppRecommend({ apps, onDownload }: AppRecommendProps) {
  return (
    <section id="watch-apps" className="scroll-mt-24">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-900">适配的看片APP</h2>
          <p className="mt-1 text-xs text-foreground-500">根据影片类型与观看设备，为你整理以下工具。</p>
        </div>
        <Link to="/app" className="text-xs text-foreground-500 hover:text-primary-600 whitespace-nowrap">
          查看全部应用
          <i className="ri-arrow-right-s-line align-middle"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {apps.map((app) => (
          <div key={app.id} className="rounded-lg border border-background-200/80 bg-background-50 p-4 flex flex-col">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-md overflow-hidden bg-primary-900 shrink-0">
                <img
                  src={app.icon}
                  alt={`${app.name}图标`}
                  title={`${app.name} - 看片应用推荐`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="min-w-0">
                <Link
                  to={`/app/detail/${app.id}`}
                  className="text-sm font-semibold text-foreground-900 hover:text-primary-600 transition-colors truncate block"
                >
                  {app.name}
                </Link>
                <p className="mt-0.5 text-[11px] text-foreground-500 truncate">
                  {app.category} · {app.platforms.join(" / ")}
                </p>
              </div>
            </div>
            <p className="mt-3 text-xs leading-6 text-foreground-600 line-clamp-2 flex-1">{app.summary}</p>
            <div className="mt-4 flex items-center gap-2">
              <button
                type="button"
                onClick={() => onDownload(app)}
                className="flex-1 inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-md bg-primary-500 text-background-50 text-xs whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                下载
              </button>
              <Link
                to={`/app/detail/${app.id}`}
                className="px-3 py-1.5 rounded-md border border-background-300 text-xs text-foreground-600 whitespace-nowrap hover:border-primary-300 transition-colors"
              >
                详情
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}